// extracted by mini-css-extract-plugin
module.exports = {"digit":"animated_digit_digit__EBaun","animate_up":"animated_digit_animate_up__NbFAX","animate_down":"animated_digit_animate_down__tRhWD"};